import React from 'react'
import PropTypes from 'prop-types'

import { useMediaQuery } from '../../../elements/MediaQueryProvider'
import { colors } from '../../../themes'
import PopupTip from '../../../elements/PopupTip'
import Tooltip from '../../../elements/Tooltip'

const TooltipPopupTip = ({
  content,
  trigger,
  position = 'top',
  breakpoint = 'desktop',
  className,
  onOpen = () => {},
  useMediaQueryProp = useMediaQuery,
}) => {
  const { isPhoneOrLarger, isTabletOrLarger, isDesktopOrLarger } = useMediaQueryProp()
  let matchesBreakpoint

  switch (breakpoint) {
    case 'phone':
      matchesBreakpoint = isPhoneOrLarger
      break
    case 'tablet':
      matchesBreakpoint = isTabletOrLarger
      break
    default:
      matchesBreakpoint = isDesktopOrLarger
      break
  }

  return matchesBreakpoint ? (
    <Tooltip color={colors.grayChateau} trigger={trigger} position={position} className={className} onOpen={onOpen}>
      {content}
    </Tooltip>
  ) : (
    <PopupTip color={colors.grayChateau} trigger={trigger} className={className} onOpen={onOpen}>
      {content}
    </PopupTip>
  )
}

TooltipPopupTip.propTypes = {
  content: PropTypes.node.isRequired,
  trigger: PropTypes.func.isRequired,
  position: PropTypes.string,
  breakpoint: PropTypes.oneOf(['', 'phone', 'tablet', 'desktop']),
  className: PropTypes.string,
  onOpen: PropTypes.func,
  useMediaQueryProp: PropTypes.func,
}

export default TooltipPopupTip
